module.exports = __webpack_public_path__ + "static/media/photo286.d2ef04c5.jpg";